"use strict";
// from redux-form https://github.com/erikras/redux-form/blob/37ab5ae7647be6d178c2d2bb871cd6c638762f4c/src/events/isEvent.js
Object.defineProperty(exports, "__esModule", { value: true });
// Determing if value passed via onChange is an React synthetic event
const isEvent = candidate => !!(candidate && candidate.stopPropagation && candidate.preventDefault);
exports.default = isEvent;
//# sourceMappingURL=is-event.js.map